import { gql } from 'apollo-angular'

/**
 * Basic author information fragment Contains the essential fields for
 * displaying an author
 */
export const AUTHOR_BASIC_FIELDS = gql`
  fragment AuthorBasicFields on Author {
    id
    name
    pre_title
    initials
    first_name
    middle_name
    last_name
    post_title
    pdf_author_name
    social_link
  }
`

/**
 * Extended author information fragment Includes function field in addition to
 * basic fields
 */
export const AUTHOR_EXTENDED_FIELDS = gql`
  fragment AuthorExtendedFields on Author {
    ...AuthorBasicFields
    function
  }
  ${AUTHOR_BASIC_FIELDS}
`

/**
 * Complete author information fragment Includes all fields needed for detailed
 * author information
 */
export const AUTHOR_COMPLETE_FIELDS = gql`
  fragment AuthorCompleteFields on Author {
    ...AuthorExtendedFields
    email
    about
    social_link
    company_name
    department
    function
    firm_page
  }
  ${AUTHOR_EXTENDED_FIELDS}
`
